import React, {useState} from 'react';
import mobile from '../img/header/mobile.jpg'
import { motion } from 'framer-motion';
import { transition1 } from '../transitions';
//laptop images
import header from '../img/header/headernew.jpg'
import sunflower from '../img/header/sunflower.jpg'
import field from '../img/header/field.jpg'
import city from '../img/header/city.jpg'
import jelly from '../img/header/jelly.jpg'
import santa from '../img/header/santa.jpg'
import shoes from '../img/header/shoes.jpg'
import fire from '../img/header/fire.jpg'
//mobile images


import {MdOutlineArrowForwardIos} from 'react-icons/md'
import {MdOutlineArrowBackIos} from 'react-icons/md'


const images = [sunflower, header, shoes, fire, field, city, jelly, santa]

const Hero = () => {

  const [currentImage, setCurrentImage] = useState(0);

  const nextImage = () => {
    setCurrentImage((prevIndex) => (prevIndex + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prevIndex) => (prevIndex - 1 + images.length) % images.length);
  };


  return (

    <>
      <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section lg:block xl:block hidden'
      style={{ position: 'relative' }}
    >

<div className='relative flex top-40 items-center'>
  <img src={images[currentImage]} alt='' height={1000} className='relative z-10 ' />
   <div className='absolute  items-center bg-red text-left p-4' style={{ left: '5%', zIndex: '20' }}>
    <h1 className='h1 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] text-white mx-auto'>Soroush's</h1>
  </div>
  <div className='absolute items-center bg-blue text-right p-4' style={{ right: '7%', zIndex: '20' }}>
    <h1 className='h1 drop-shadow-[0_1.2px_1.2px_rgba(0,0,0,0.8)] text-white  mx-auto'>Portfolio</h1>
  </div>
  <div className='absolute ml-4 text-white font-extrabold hover:text-yellow-400' style={{ zIndex: '30' }}>
  <button onClick={prevImage}><MdOutlineArrowBackIos size={65}/></button>
  </div>
  <div className='absolute right-0 mr-4 text-white font-extrabold hover:text-yellow-400' style={{ zIndex: '30' }}>
  <button onClick={nextImage}><MdOutlineArrowForwardIos size={65}/></button>
  </div>
  

</div>


    </motion.section>

    <motion.section
      initial={{ opacity: 0, y: '100%' }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: '100%' }}
      transition={transition1}
      className='section  lg:hidden xl:hidden md:hidden sm:hidden'
    >

<div className='relative flex items-center justify-center'>
  {/*<div className='absolute ml-4 text-white font-extrabold hover:text-yellow-400' style={{ zIndex: '30', left: 0 }}>
    <button onClick={prevImage}><MdOutlineArrowBackIos size={65}/></button>
    </div> */}
  <img src={mobile} alt='' height={1000} className='relative z-10 ' />
  {/*<div className='absolute right-0 mr-4 text-white font-extrabold hover:text-yellow-400' style={{ zIndex: '30' }}>
    <button onClick={nextImage}><MdOutlineArrowForwardIos size={65}/></button>
  </div>*/}
  
</div>

    </motion.section>
    </>
    
  );
};

export default Hero;
